import React, { useState, useRef, useEffect } from 'react';
import ChatHeader from '../components/ChatHeader';
import ChatWindow from '../components/ChatWindow';
import ChatInput from '../components/ChatInput';
import ContactModal from '../components/ContactModal';
import TechStackModal from '../components/TechStackModal';
import { sendChatMessage } from '../services/api';
import './ChatPage.css';

function ChatPage() {
  const [messages, setMessages] = useState([
    {
      type: 'bot',
      text: 'Hallo! Ich bin der persönliche Chatbot von Philipp Staufenberger. Ich kann Ihnen Informationen über seine Kompetenzen als AI & Data Automation Engineer geben. Was möchten Sie wissen?',
      timestamp: new Date()
    }
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [conversationId, setConversationId] = useState(null);
  const [showSources, setShowSources] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [showTechStackModal, setShowTechStackModal] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(true);
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    // Only scroll on new messages, not on initial load
    if (messages.length > 1) {
      scrollToBottom();
    }
  }, [messages]);

  const handleSendMessage = async (messageText) => {
    if (!messageText.trim()) return;

    // Hide suggestions after first user message
    setShowSuggestions(false);

    // Add user message
    const userMessage = {
      type: 'user',
      text: messageText,
      timestamp: new Date()
    };
    setMessages(prev => [...prev, userMessage]);
    setIsLoading(true);

    try {
      // Send to backend
      const response = await sendChatMessage(messageText, conversationId);

      // Update conversation ID
      if (!conversationId) {
        setConversationId(response.conversation_id);
      }

      // Check if contact modal should be shown
      if (response.show_contact_modal) {
        setShowContactModal(true);
      }

      // Add bot response
      const botMessage = {
        type: 'bot',
        text: response.answer,
        sources: response.sources,
        timestamp: new Date()
      };
      setMessages(prev => [...prev, botMessage]);
    } catch (error) {
      console.error('Error sending message:', error);

      // Add error message
      const errorMessage = {
        type: 'bot',
        text: 'Entschuldigung, es gab einen Fehler. Bitte stellen Sie sicher, dass das Backend läuft und die Knowledge Base geladen ist.',
        timestamp: new Date()
      };
      setMessages(prev => [...prev, errorMessage]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="chat-page">
      <ChatHeader
        showSources={showSources}
        onToggleSources={() => setShowSources(!showSources)}
        onShowTechStack={() => setShowTechStackModal(true)}
        onShowContact={() => setShowContactModal(true)}
      />
      <ChatWindow
        messages={messages}
        isLoading={isLoading}
        messagesEndRef={messagesEndRef}
        showSources={showSources}
        onSuggestionClick={handleSendMessage}
        showSuggestions={showSuggestions}
      />
      <ChatInput onSendMessage={handleSendMessage} disabled={isLoading} />
      <ContactModal isOpen={showContactModal} onClose={() => setShowContactModal(false)} />
      <TechStackModal isOpen={showTechStackModal} onClose={() => setShowTechStackModal(false)} />
    </div>
  );
}

export default ChatPage;
